import { useEffect, useState } from "react";
import { api, unwrapObject } from "@/lib/api";

export type AiFeature = "LEAD_ENQUIRY" | "WHATSAPP_REPLY" | "TIDY_NOTES" | "EMAIL_DRAFT" | "DEAL_HEALTH" | "DAILY_BRIEF" | "ASK_CRM" | "CALL_TRANSCRIPT" | "CALL_SUMMARY" | "CALL_COACHING" | "AGENT" | "TEMPLATE_FROM_SAMPLE";
interface Availability {
  ready: boolean;
  features: Record<AiFeature, boolean>;
}

let cache: Promise<Availability | null> | null = null;

/** Whether an AI feature can be used right now (AI on, key set, feature switched on); fetched once per page load */
export function useAiFeature(feature: AiFeature, allowed = true) {
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (!allowed) return;
    cache ??= api
      .get("/api/Ai/Available")
      .then((r) => unwrapObject<Availability>(r))
      .catch(() => {
        cache = null;
        return null;
      });
    void cache.then((a) => setOn(!!a?.ready && !!a.features?.[feature]));
  }, [feature, allowed]);
  return on;
}

/** Tells the server whether a suggestion was used (as is or edited) or dismissed; never blocks the user */
export function aiFeedback(suggestionId: string | null | undefined, accepted: boolean, edited = false) {
  if (!suggestionId) return;
  void api.post(`/api/Ai/Feedback/${suggestionId}`, { accepted, edited }).catch(() => undefined);
}
